/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Paper,
  Button,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import useStyles from './styles'; // Importa los estilos desde Styles.js
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import { clientAxios8080 } from '../../../../configs/axios';
import LoadingOverlay from "../../../loading-overlay";
// Componente principal
function InmuebleDetalle() {
  // Aplica los estilos
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  // Estado para los datos de inmuebles y el modal
  const [inmuebles, setInmuebles] = useState([]);
  const [entidades, setEntidades] = useState([]);
  const [areas, setAreas] = useState([]);
  const [criticidades, setCriticidades] = useState([]);
  const [tipoConsumos, setTipoConsumos] = useState([]);
  const [tipoInmuebles, setTipoInmuebles] = useState([]);
  const [grupoInmuebles, setGrupoInmuebles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInmuebleId, setModalInmuebleId] = useState(null);
  const [modalNombre, setModalNombre] = useState('');
  const [modalDomicilio, setModalDomicilio] = useState('');
  const [modalEntidadId, setModalEntidadId] = useState('');
  const [modalSitioId, setModalSitioId] = useState('');
  const [modalTiposConsumoId, setModalTiposConsumoId] = useState('');
  const [modalAreaId, setModalAreaId] = useState('');
  const [modalTipoInmuebleId, setModalTipoInmuebleId] = useState('');
  const [modalGrupoInmuebleId, setModalGrupoInmuebleId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [entidadIdError, setEntidadIdError] = useState('');
  const [sitioIdError, setSitioIdError] = useState('');
  const [tiposConsumoIdError, setTiposConsumoIdError] = useState('');
  const [areaIdError, setAreaIdError] = useState('');
  const [tipoInmuebleIdError, setTipoInmuebleIdError] = useState('');
  const [grupoInmuebleIdError, setGrupoInmuebleIdError] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [domicilioError, setDomicilioError] = useState('');
  const [modalFechaCreacion, setModalFechaCreacion] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [modalEntidadIdSelect, setModalEntidadIdSelect] = useState('');
  const [modalSitioIdSelect, setModalSitioIdSelect] = useState('');
  const [modalTipoConsumoIdSelect, setModalTipoConsumoIdSelect] = useState('');
  const [modalAreaIdSelect, setModalAreaIdSelect] = useState('');
  const [modalTipoInmuebleIdSelect, setModalTipoInmuebleIdSelect] = useState('');
  const [modalGrupoInmuebleIdSelect, setModalGrupoInmuebleIdSelect] = useState('');
  const [orderBy, setOrderBy] = useState('inmuebleId'); // Inicialmente, ordena por ID ascendente
  const [orderDirection, setOrderDirection] = useState('asc'); // Inicialmente, en orden ascendente
  const [orderByFechaCreacion, setOrderByFechaCreacion] = useState('asc'); // Inicialmente, ordena por fecha de creación ascendente
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Esto define rowsPerPage y su función para cambiar el valor
  const formattedDate = new Date().toISOString();
  const [switchState, setSwitchState] = useState(true);

  const modalStyle = {
    position: 'absolute',
    width: '50%',
    bgcolor: 'background.paper',
    p: 4,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto',
    maxHeight: '100vh',
  };

  async function getInmueble() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/inmuebleByGrupoAndRegion');
      const responseData = response.data;
      // Ordena los datos por 'id' de forma predeterminada
      responseData.sort((a, b) => a.inmuebleId - b.inmuebleId);
      setInmuebles(responseData);
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)
    }
  }

  async function getEntidad() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/entidad');
      const responseData = response.data.data.filter((entidad) => entidad.status === true);
      setEntidades(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getArea() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/area');
      const responseData = response.data.data.filter((area) => area.status === true);
      console.log('Response Area:', responseData);
      setAreas(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getCriticidad() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/criticidad/sitio');
      const responseData = response.data.data.filter((criticidad) => criticidad.status === true);
      console.log('Response Criticidad:', responseData);
      setCriticidades(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getTipoConsumo() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/consumo');
      const responseData = response.data.data.filter((tipoConsumo) => tipoConsumo.status === true);
      console.log('Response Tipo Consumo:', responseData);
      setTipoConsumos(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getTipoInmueble() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/inmueble');
      const responseData = response.data.data.filter((tipoInmueble) => tipoInmueble.status === true);
      setTipoInmuebles(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getGrupoInmueble() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/grupoinmueble');
      const responseData = response.data.data.filter((grupoInmueble) => grupoInmueble.status === true);
      console.log('Response Grupo Inmueble:', responseData);
      setGrupoInmuebles(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const postInmueble = async () => {
    try {
      const newInmuebleData = {
        claveCriticidadSitio: modalSitioIdSelect,
        domicilio: modalDomicilio,
        dsInmueble: modalNombre,
        entidadId: modalEntidadIdSelect,
        fechaCreacion: formattedDate,
        grupoInmuebleId: modalGrupoInmuebleIdSelect,
        idArea: modalAreaIdSelect,
        status: modalStatus,
        tipoConsumoId: modalTipoConsumoIdSelect,
        tipoInmuebleId: modalTipoInmuebleIdSelect,
      };

      const response = await clientAxios8080.post('/ms-catalogos/filtros/inmueble', newInmuebleData);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro creado con éxito',
          showConfirmButton: false,
          timer: 1200,
        });
        getInmueble();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)

      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const putInmueble = async () => {
    try {
      const updatedInmuebleData = {
        inmuebleId: modalInmuebleId,
        dsInmueble: modalNombre,
        domicilio: modalDomicilio,
        entidadId: modalEntidadIdSelect,
        idArea: modalAreaIdSelect,
        claveCriticidadSitio: modalSitioIdSelect,
        tipoConsumoId: modalTipoConsumoIdSelect,
        tipoInmuebleId: modalTipoInmuebleIdSelect,
        grupoInmuebleId: modalGrupoInmuebleIdSelect,
        status: modalStatus,
        fechaCreacion: formattedDate,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/inmueble/', updatedInmuebleData);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro editado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getInmueble();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const deleteInmueble = async (inmuebleId) => {
    setLoading(true)
    try {
      const response = await clientAxios8080.delete(`/ms-catalogos/filtros/inmueble?id=${inmuebleId}`);

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro eliminado con éxito.',
          showConfirmButton: false,
          timer: 2400,
        });
        getInmueble();
      } else {
        const inmueble = inmuebles.find((i) => i.inmuebleId === inmuebleId); // Encuentra el inmueble por su ID
        // Check if the response has an error message
        if (response.data && response.data.error) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el inmueble.',
            text: `Asegúrese de eliminar primero los sitios que usan el inmueble: "${inmueble.dsInmueble}".`,
            showConfirmButton: true,
          });
        } else {
          // If no specific error message, show a generic error message
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el inmueble.',
            text: 'Asegúrese de eliminar primero las dependencias.',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
    } catch (error) {
      // Handle network or other errors
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al enviar la solicitud DELETE.',
        showConfirmButton: false,
        timer: 1200,
      });
    }
  };

  useEffect(() => {
    getInmueble();
    getEntidad();
    getCriticidad();
    getTipoConsumo();
    getTipoInmueble();
    getGrupoInmueble();
    getArea();
  }, []);

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setIsModalOpen(true);
    setModalInmuebleId(null);
    setModalNombre('');
    setNombreError('');
    setModalDomicilio('');
    setDomicilioError('');
    setModalEntidadIdSelect('');
    setEntidadIdError('');
    setModalSitioIdSelect('');
    setSitioIdError('');
    setModalTipoConsumoIdSelect('');
    setTiposConsumoIdError('');
    setModalAreaIdSelect('');
    setAreaIdError('');
    setModalTipoInmuebleIdSelect('');
    setTipoInmuebleIdError('');
    setModalGrupoInmuebleIdSelect('');
    setGrupoInmuebleIdError('');
    setModalFechaCreacion(formattedDate);
    setModalStatus(true);
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = (
    inmuebleId,
    dsInmueble,
    domicilio,
    entidadId,
    idArea,
    claveCriticidadSitio,
    tipoConsumoId,
    tipoInmuebleId,
    grupoInmuebleId,
    fechaCreacion,
    status
  ) => {
    setIsModalOpen(true);
    setModalInmuebleId(inmuebleId);
    setModalNombre(dsInmueble);
    setModalDomicilio(domicilio);
    setModalEntidadIdSelect(entidadId);
    setModalSitioIdSelect(claveCriticidadSitio);
    setModalTipoConsumoIdSelect(tipoConsumoId);
    setModalAreaIdSelect(idArea);
    setModalTipoInmuebleIdSelect(tipoInmuebleId);
    setModalGrupoInmuebleIdSelect(grupoInmuebleId);
    setModalFechaCreacion(fechaCreacion);
    setModalStatus(status);
    setNombreError('');
    setDomicilioError('');
    setEntidadIdError('');
    setSitioIdError('');
    setTiposConsumoIdError('');
    setAreaIdError('');
    setTipoInmuebleIdError('');
    setGrupoInmuebleIdError('');
  };

  // Maneja el cambio en el campo "Nombre"
  const handleNombreChange = (e) => {
    const newName = e.target.value;
    setModalNombre(newName);

    if (newName.trim().length === 0) {
      setNombreError('El inmueble no puede estar vacío.');
    } else if (newName.trim().length < 3) {
      setNombreError('El inmueble debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newName)) {
        setNombreError('');
      } else {
        setNombreError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  // Maneja el cambio en el campo "Domicilio"
  const handleDomicilioChange = (e) => {
    const newName = e.target.value;
    setModalDomicilio(newName);

    if (newName.trim().length === 0) {
      setDomicilioError('El domicilio no puede estar vacío.');
    } else if (newName.trim().length < 3) {
      setDomicilioError('El domicilio debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newName)) {
        setDomicilioError('');
      } else {
        setDomicilioError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (inmuebleId) => {
    try {
      // Busca el inmueble en el estado actual
      const inmuebleToUpdate = inmuebles.find((inmueble) => inmueble.inmuebleId === inmuebleId);

      // Realiza el cambio localmente en el estado
      setInmuebles((prevInmuebles) =>
        prevInmuebles.map((inmueble) => {
          if (inmueble.inmuebleId === inmuebleId) {
            const updatedInmuebleData = { ...inmueble, status: !inmueble.status };
            const title = updatedInmuebleData.status ? 'Inmueble activado exitosamente.' : 'Inmueble desactivado exitosamente.';
            Swal.fire({
              position: 'center',
              icon: 'success',
              title,
              showConfirmButton: false,
              timer: 1200,
            });

            return updatedInmuebleData;
          }
          return inmueble;
        })
      );

      // Aquí se debe acceder directamente a inmuebleToUpdate en lugar de intentar acceder a inmueble fuera del bloque map
      const updatedInmuebleData = {
        inmuebleId: inmuebleToUpdate.inmuebleId,
        dsInmueble: inmuebleToUpdate.dsInmueble,
        domicilio: inmuebleToUpdate.domicilio,
        entidadId: inmuebleToUpdate.entidadId,
        idArea: inmuebleToUpdate.idArea,
        claveCriticidadSitio: inmuebleToUpdate.claveCriticidadSitio,
        tipoConsumoId: inmuebleToUpdate.tipoConsumoId,
        status: !inmuebleToUpdate.status,
        tipoInmuebleId: inmuebleToUpdate.tipoInmuebleId,
        grupoInmuebleId: inmuebleToUpdate.grupoInmuebleId,
        fechaCreacion: inmuebleToUpdate.fechaCreacion,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/inmueble/', updatedInmuebleData);

      if (response.status === 200) {
        getInmueble();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    setLoading(true)
    const entidadIdToSave = modalEntidadIdSelect;
    const sitioIdToSave = modalSitioIdSelect;
    const tiposConsumoIdToSave = modalTipoConsumoIdSelect;
    const areaIdToSave = modalAreaIdSelect;
    const tipoInmuebleIdToSave = modalTipoInmuebleIdSelect;
    const grupoInmuebleIdToSave = modalGrupoInmuebleIdSelect;

    // Valida los errores de entrada
    let newEntidadIdError = '';
    let newSitioIdError = '';
    let newTiposConsumoIdError = '';
    let newAreaIdError = '';
    let newTipoInmuebleIdError = '';
    let newGrupoInmuebleIdError = '';
    let newNombreError = '';
    let newDomicilioError = '';

    if (!entidadIdToSave) {
      newEntidadIdError = 'Debe seleccionar una entidad.';
    }
    if (!sitioIdToSave) {
      newSitioIdError = 'Debe seleccionar un inmueble.';
    }
    if (!tiposConsumoIdToSave) {
      newTiposConsumoIdError = 'Debe seleccionar un tipo de consumo.';
    }
    if (!areaIdToSave) {
      newAreaIdError = 'Debe seleccionar un área.';
    }
    if (!tipoInmuebleIdToSave) {
      newTipoInmuebleIdError = 'Debe seleccionar un tipo de inmueble.';
    }
    if (!grupoInmuebleIdToSave) {
      newGrupoInmuebleIdError = 'Debe seleccionar un grupo de inmueble.';
    }
    if (modalNombre.trim().length === 0) {
      newNombreError = 'El inmueble no puede estar vacío.';
    } else if (modalNombre.trim().length < 3) {
      newNombreError = 'El inmueble debe tener al menos 3 caracteres.';
    }
    if (modalDomicilio.trim().length === 0) {
      newDomicilioError = 'El domicilio no puede estar vacío.';
    } else if (modalDomicilio.trim().length < 3) {
      newDomicilioError = 'El domicilio debe tener al menos 3 caracteres.';
    }

    setEntidadIdError(newEntidadIdError);
    setSitioIdError(newSitioIdError);
    setTiposConsumoIdError(newTiposConsumoIdError);
    setAreaIdError(newAreaIdError);
    setTipoInmuebleIdError(newTipoInmuebleIdError);
    setGrupoInmuebleIdError(newGrupoInmuebleIdError);

    setNombreError(newNombreError);
    setDomicilioError(newDomicilioError);

    // Si no hay errores, guarda la inmueble
    if (
      !newGrupoInmuebleIdError &&
      !newTipoInmuebleIdError &&
      !newTiposConsumoIdError &&
      !newSitioIdError &&
      !newEntidadIdError &&
      !newNombreError &&
      !newDomicilioError
    ) {
      if (modalInmuebleId !== null) {
        // Actualizar inmueble existente
        try {
          await putInmueble(); // Suponiendo que putInmueble devuelve una Promise
         
        } catch (error) {
          // Mostrar el mensaje de error en caso de fallo
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al actualizar el registro',
            text: 'Por favor, inténtalo de nuevo.',
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        // Agregar nueva inmueble
        try {
          await postInmueble(); // Suponiendo que postInmueble devuelve una Promise
         
        } catch (error) {
          setLoading(false)
          // Mostrar el mensaje de error en caso de fallo
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al agregar el nuevo registro',
            text: 'Por favor, inténtalo de nuevo.',
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
      // Cerrar el modal y resetear los campos
      setIsModalOpen(false);
      setModalInmuebleId(null);
      setModalNombre('');
      setModalDomicilio('');
      setModalEntidadIdSelect('');
      setEntidadIdError('');
      setModalSitioIdSelect('');
      setSitioIdError('');
      setModalTipoConsumoIdSelect('');
      setTiposConsumoIdError('');
      setModalAreaIdSelect('');
      setAreaIdError('');
      setModalTipoInmuebleIdSelect('');
      setTipoInmuebleIdError('');
      setModalGrupoInmuebleIdSelect('');
      setGrupoInmuebleIdError('');
      if (modalNombre.trim().length >= 3) {
        setNombreError('');
      }
      if (modalDomicilio.trim().length >= 3) {
        setDomicilioError('');
      }
    }
  };

  // Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = (inmuebleId) => {
    const inmueble = inmuebles.find((i) => i.inmuebleId === inmuebleId); // Encuentra el inmueble por su ID

    Swal.fire({
      title: `Estás a punto de eliminar el inmueble: "${inmueble.dsInmueble}".`,
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the deleteRegion function to delete the entity
          const response = await deleteInmueble(inmuebleId);

          if (response && response.status === 200) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Registro eliminado con éxito.',
              showConfirmButton: false,
              timer: 1200,
            });
            setLoading(false)
          } else if (response && response.status === 500) {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Error al eliminar el inmueble.',
              text: 'Asegúrese de eliminar primero las dependencias.',
              showConfirmButton: false,
              timer: 2400,
            });
          }
          setLoading(false)
        } catch (error) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el registro.',
            text: 'Asegúrese de eliminar primero las dependencias.',
            showConfirmButton: false,
            timer: 2400,
          });
          setLoading(false)
        }
      }
    });
  };

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filteredInmuebles = inmuebles.filter((inmueble) => {
    const searchValueWithoutAccents = removeAccents(searchValue.toLowerCase());

    return (
      removeAccents(inmueble.dsInmueble.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.domicilio.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.dsEntidad.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.dsCriticidadSitio.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.tipoConsumo.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.dsArea.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.dstipoInmueble.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(inmueble.dsGrupoInmueble.toLowerCase()).includes(searchValueWithoutAccents)
    );
  });

  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Detalle del Catálogo para Inmuebles</h1>
      <div className={classes.addButtonStyle}>
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <div className={classes.selectContainer}>
          <Select id="rows-per-page-select" value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
            <MenuItem value={10}>Mostrar 10 elementos</MenuItem>
            <MenuItem value={50}>Mostrar 50 elementos</MenuItem>
            <MenuItem value={inmuebles.length}>Todos los elementos</MenuItem>
          </Select>
        </div>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} style={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center">Id</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Entidad</TableCell>
              <TableCell align="center">Domicilio</TableCell>
              <TableCell align="center">Sitio</TableCell>
              <TableCell align="center">Tipo Consumo</TableCell>
              <TableCell align="center">Area</TableCell>
              <TableCell align="center">Tipo Inmueble</TableCell>
              <TableCell align="center">Grupo Inmueble</TableCell>
              <TableCell align="center">Fecha de Creación</TableCell>
              <TableCell align="center">Estatus</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredInmuebles.length === 0 ? (
              <TableRow>
                <TableCell colSpan={13} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              filteredInmuebles.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((inmueble) => (
                <TableRow key={inmueble.inmuebleId}>
                  <TableCell align="center">{inmueble.inmuebleId}</TableCell>
                  <TableCell align="center">{inmueble.dsInmueble}</TableCell>
                  <TableCell align="center">{inmueble.dsEntidad}</TableCell>
                  <TableCell align="center">{inmueble.domicilio}</TableCell>
                  <TableCell align="center">{inmueble.dsCriticidadSitio}</TableCell>
                  <TableCell align="center">{inmueble.tipoConsumo}</TableCell>
                  <TableCell align="center">{inmueble.dsArea}</TableCell>
                  <TableCell align="center">{inmueble.dstipoInmueble}</TableCell>
                  <TableCell align="center">{inmueble.dsGrupoInmueble}</TableCell>
                  <TableCell align="center">{format(new Date(inmueble.fechaCreacion), 'yyyy-MM-dd')}</TableCell>
                  <TableCell align="center">
                    <div className={classes.centeredSwitch}>
                      <Switch
                        checked={inmueble.status}
                        onChange={() => handleStatusChange(inmueble.inmuebleId)}
                        className={classes.customSwitch}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={editarImage}
                        alt="Editar"
                        className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                        onClick={() =>
                          handleEditarClick(
                            inmueble.inmuebleId,
                            inmueble.dsInmueble,
                            inmueble.domicilio,
                            inmueble.entidadId,
                            inmueble.idArea,
                            inmueble.claveCriticidadSitio,
                            inmueble.tipoConsumoId,
                            inmueble.tipoInmuebleId,
                            inmueble.grupoInmuebleId,
                            inmueble.fcFechaCreacion,
                            inmueble.status
                          )
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={eliminarImage}
                        alt="Eliminar"
                        className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                        onClick={() => handleEliminarClick(inmueble.inmuebleId)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className={classes.pagination}>
            <IconButton onClick={() => setPage(0)} disabled={page === 0} aria-label="Primera página">
              <FirstPageIcon />
            </IconButton>
            <IconButton onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0} aria-label="Página anterior">
              <NavigateBeforeIcon />
            </IconButton>
            <span>
              {page + 1} de {Math.ceil(inmuebles.length / rowsPerPage)}
            </span>
            <IconButton
              onClick={() => setPage(Math.min(page + 1, Math.floor(inmuebles.length / rowsPerPage)))}
              disabled={page >= Math.floor(inmuebles.length / rowsPerPage)}
              aria-label="Página siguiente"
            >
              <NavigateNextIcon />
            </IconButton>
            <IconButton
              onClick={() => setPage(Math.floor(inmuebles.length / rowsPerPage))}
              disabled={page >= Math.floor(inmuebles.length / rowsPerPage)}
              aria-label="Última página"
            >
              <LastPageIcon />
            </IconButton>
          </div>
        </div>
      </TableContainer>
      {loading && <LoadingOverlay />}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={modalStyle}>
          <h2>{modalInmuebleId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <TextField
            label="Nombre"
            variant="outlined"
            value={modalNombre}
            onChange={handleNombreChange}
            className={classes.modalTextField}
            error={nombreError !== ''}
            helperText={nombreError}
          />
          <TextField
            label="Domicilio"
            variant="outlined"
            value={modalDomicilio}
            onChange={handleDomicilioChange}
            className={classes.modalTextField}
            error={domicilioError !== ''}
            helperText={domicilioError}
          />
          <FormControl className={classes.modalTextField} error={Boolean(entidadIdError)}>
            <InputLabel id="entidad-select-label" htmlFor="entidad-select" {...(entidadIdError ? { style: { color: 'red' } } : {})}>
              Entidad
            </InputLabel>
            <Select
              labelId="entidad-select-label"
              id="entidad-select"
              value={modalEntidadIdSelect}
              onChange={(e) => setModalEntidadIdSelect(e.target.value)}
            >
              {entidades.map((entidad) => (
                <MenuItem key={entidad.entidadId} value={entidad.entidadId}>
                  {entidad.dsEntidad}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{entidadIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(areaIdError)}>
            <InputLabel id="area-select-label" htmlFor="area-select" {...(areaIdError ? { style: { color: 'red' } } : {})}>
              Area
            </InputLabel>
            <Select
              labelId="area-select-label"
              id="area-select"
              value={modalAreaIdSelect}
              onChange={(e) => setModalAreaIdSelect(e.target.value)}
            >
              {areas.map((area) => (
                <MenuItem key={area.idArea} value={area.idArea}>
                  {area.dsArea}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{areaIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(sitioIdError)}>
            <InputLabel id="criticidad-select-label" htmlFor="criticidad-select" {...(sitioIdError ? { style: { color: 'red' } } : {})}>
              Criticidad
            </InputLabel>
            <Select
              labelId="criticidad-select-label"
              id="criticidad-select"
              value={modalSitioIdSelect}
              onChange={(e) => setModalSitioIdSelect(e.target.value)}
            >
              {criticidades.map((criticidad) => (
                <MenuItem key={criticidad.claveCriticidadSitio} value={criticidad.claveCriticidadSitio}>
                  {criticidad.dsCriticidadSitio}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{sitioIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(tiposConsumoIdError)}>
            <InputLabel
              id="tipoConsumo-select-label"
              htmlFor="tipoConsumo-select"
              {...(tiposConsumoIdError ? { style: { color: 'red' } } : {})}
            >
              Tipo Consumo
            </InputLabel>
            <Select
              labelId="tipoConsumo-select-label"
              id="tipoConsumo-select"
              value={modalTipoConsumoIdSelect}
              onChange={(e) => setModalTipoConsumoIdSelect(e.target.value)}
            >
              {tipoConsumos.map((tipoConsumo) => (
                <MenuItem key={tipoConsumo.tipoConsumoId} value={tipoConsumo.tipoConsumoId}>
                  {tipoConsumo.tipoConsumo}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{tiposConsumoIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(tipoInmuebleIdError)}>
            <InputLabel
              id="tipoInmueble-select-label"
              htmlFor="tipoInmueble-select"
              {...(tipoInmuebleIdError ? { style: { color: 'red' } } : {})}
            >
              Tipo Inmueble
            </InputLabel>
            <Select
              labelId="tipoInmueble-select-label"
              id="tipoInmueble-select"
              value={modalTipoInmuebleIdSelect}
              onChange={(e) => setModalTipoInmuebleIdSelect(e.target.value)}
            >
              {tipoInmuebles.map((tipoInmueble) => (
                <MenuItem key={tipoInmueble.tipoInmuebleId} value={tipoInmueble.tipoInmuebleId}>
                  {tipoInmueble.dstipoInmueble}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{tipoInmuebleIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(grupoInmuebleIdError)}>
            <InputLabel
              id="grupoInmueble-select-label"
              htmlFor="grupoInmueble-select"
              {...(grupoInmuebleIdError ? { style: { color: 'red' } } : {})}
            >
              Grupo Inmueble
            </InputLabel>
            <Select
              labelId="grupoInmueble-select-label"
              id="grupoInmueble-select"
              value={modalGrupoInmuebleIdSelect}
              onChange={(e) => setModalGrupoInmuebleIdSelect(e.target.value)}
            >
              {grupoInmuebles.map((grupoInmueble) => (
                <MenuItem key={grupoInmueble.grupoInmuebleId} value={grupoInmueble.grupoInmuebleId}>
                  {grupoInmueble.dsGrupoInmueble}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{grupoInmuebleIdError}</FormHelperText>
          </FormControl>

          <div className={classes.modalButtons}>
            <Button variant="contained" color="primary" onClick={handleGuardarClick} className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default InmuebleDetalle;
